export var AnimationState;
(function (AnimationState) {
  AnimationState[AnimationState["playing"] = 0] = "playing";
  AnimationState[AnimationState["paused"] = 1] = "paused";
})(AnimationState || (AnimationState = {}));